module.exports = __webpack_public_path__ + "static/media/logo.3fa16e10.png";